<template>
<div>
    <v-layout row justify-center>
        <v-flex xs12 lg6>
            <v-card class="dash-card elevation-3">
                <v-img src="../../../static/img/dewbk.jpg" height="250px">
                </v-img>
                <v-card-title primary-title>
                    <v-layout row>
                        <v-flex>
                            <div class="headline">{{getString('Dew Studio')}}</div>
                            <span class="grey--text">Sviluppo Software</span>
                        </v-flex>
                        <v-flex style="text-align:right">
                            <img src="../../../static/img/quadrato.png" class="logo-size" style="display:inline-block" />
                      </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <!-- <p>
                        {{getString('Dew Studio nasce come idea di ')}}<b>{{getString('Andrea Vincenzo Abbondanza')}}</b> {{getString(' e ')}} <b>{{getString(`Cristian d'Aulisio Garigliota`)}}</b> {{getString(' nel 2014 quando entrambi, dopo una carriera di liberi professionisti entrano nel mondo del lavoro come soci, rendendosi conto di come mancasse una figura aziendale che mettesse al primo posto la qualità del software.')}}
                    </p>
                    <p>
                        {{getString('Convinti che unendo le forze potessero ovviare a questa situazione, hanno creato Dew Studio, ove il team sempre in crescita dimostra le proprie capacità con innovativi software.')}}
                    </p> -->
                    <h3>{{getString('Riferimenti')}}</h3> 
                    <h5>{{getString(`Termini e condizioni d'uso`)}}: <a href="https://quickbe.app/eula/">{{getString('Link')}}</a></h5>
                    <h5>{{getString(`Trattamento dati`)}}: <a href="https://quickbe.app/trattamento-dati-per-quickbe-privacy-policy/">{{getString('Link')}}</a></h5>
                    <h3>{{getString('Contatti')}}</h3>
                    <h5>Email: <a href="mailto:info@dewstudio.eu">info@dewstudio.eu</a></h5>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat color="orange" @click="openDewStudio">{{getString('Visita Dew Studio')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
import ajax from '../../ajax.js'

export default {
  name: 'Info',
  mounted: function() {
    
  },
  data: () => {
    return {}
  },
  computed: {},
  methods: {
    openDewStudio: function() {
      window.open('https://www.dewstudio.eu')
    },
    getString: function(key, values) {
      return this.$store.state.currentTranslator.getString(key, values)
    }
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}

.border {
  border: 2px solid;
}

.logo-size {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/About.vue